import { types } from "../types/types";
const intitalState = {
    allVehicleModels: [],
};

const vehicleModelReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.VEHICLE_MODELS:
            return {
                ...state,
                allVehicleModels: action.payload,
            };
        default:
            return { ...state };
    }
};

export default vehicleModelReducer;
